module.exports = __webpack_public_path__ + "static/img/waipay.309c1b9b.png";